import Icon from "@expo/vector-icons/MaterialCommunityIcons";
/* -----------------Globals--------------- */
import { Card, Text } from "react-native-paper";

/* -----------------Helpers & Hooks--------------- */
import { useAppTheme } from "@hooks/useAppTheme";
/* -----------------UI--------------- */
import Box from "@memorang/ui/src/components/Box";

import { useAppStore } from "@hooks/useAppStore";
import useClerkUser from "@hooks/useClerkUser";
import type { ExamDetails } from "@memorang/types/src/exams";
/* -----------------Child components--------------- */
import {
	type Purchase,
	RedeemPostPurchase,
} from "components/RedeemPostPurchase";

type Props = {
	products: Purchase[];
	examName: string;
	title: string;
	externalPurchase?: boolean;
	examDetails?: ExamDetails;
	successfulPurchaseTitle?: string;
};
export const AccessGrantedView = ({
	products,
	examName,
	title,
	externalPurchase,
	examDetails,
	successfulPurchaseTitle,
}: Props) => {
	const { email } = useClerkUser();
	const theme = useAppTheme();
	const appFont = useAppStore((store) => store.app.font) || "opensans";

	return (
		<Box paddingBottom={24} paddingHorizontal={16} flex={1}>
			<Card>
				<Card.Content
					style={{
						paddingHorizontal: 8,
					}}
				>
					<Box gap={16}>
						<Icon
							name="check-circle"
							size={44}
							style={{
								alignSelf: "center",
							}}
							color={theme.colors.success.main}
						/>
						<Text
							variant="titleMedium"
							style={{
								textAlign: "center",
								paddingHorizontal: 16,
								fontFamily: `${appFont}-semibold`,
							}}
						>
							{title}
						</Text>
						<RedeemPostPurchase
							purchases={products}
							redeemedProductsExamName={examName}
							redeemStatus="redeemed"
							email={email}
							externalPurchase={externalPurchase}
							examDetails={examDetails}
							successfulPurchaseTitle={successfulPurchaseTitle}
						/>
					</Box>
				</Card.Content>
			</Card>
		</Box>
	);
};
